import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";
import { trackPageView } from "../../services/analytics";

/**
 * Fires a GA4 page_view on every client-side route change.
 *
 * The initial load is deliberately skipped: gtag('config', 'G-...') in
 * index.html already sends a page_view for it, and firing here too would
 * double-count the landing page of every session.
 *
 * document.title is read one tick late on purpose — react-helmet-async writes
 * the per-route title in its own effect, so reading it synchronously here
 * reports the PREVIOUS page's title.
 */
const RouteAnalytics = () => {
  const { pathname, search } = useLocation();
  const isInitialLoad = useRef(true);

  useEffect(() => {
    if (isInitialLoad.current) {
      isInitialLoad.current = false;
      return;
    }
    const timer = window.setTimeout(() => {
      trackPageView(pathname + search);
    }, 0);
    return () => window.clearTimeout(timer);
  }, [pathname, search]);

  return null;
};

export default RouteAnalytics;
